import styled, { css } from 'styled-components';

const ContentWrapper = styled.div`
  width: 812px;
  border-radius: 3px;
  background-color: var(--light-values-white);
  margin: 0 auto;
  padding: 25px 36px;
  @media (max-width: 992px) {
    width: 90%;
  }
  ${({ theme: { isRTL } }) =>
    isRTL &&
    css`
      direction: rtl;
    `}
`;

export default ContentWrapper;
